export default "__VITE_ASSET__BQy0HUMb__"